<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/press/logos/AvianInfluenzaMap.png"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          backgroundPosition="0% 20%"
          overlayGradientColor="#051238"
          title='Australian risk prediction map of avian influenza H5N1'
        />
        <div style="background-color: #e6e8e8;">
        <div style="text-align: left; min-height: 50vh; margin-left: 10%; margin-right: 10%; padding: 5vh;">
            <div>
                <h2>Australian risk prediction map of avian influenza H5N1</h2>
                <br/>
            </div>
            <div>
                July 23, 2026
                <br/><br/>
            </div>
            <div>
                The highly pathogenic avian influenza virus H5N1 has reached the Australian mainland, initially with incursions from migratory seabirds from sub-Antarctic islands. The first domestic wild bird has been confirmed with infection, which means there is now a greater chance of the virus spreading among our wildlife and farms. Poultry farming is at greatest risk, as the virus has swept through flocks overseas. Protecting our farming from this virus is critical. UNSW research from the Kirby Institute, UNSW Medicine and Health, and UNSW Engineering, has generated a tool for predicting locations with the highest risk of poultry outbreaks. This combines several layers of geographic information such as detection of new infections, wild bird flyways, wild bird abundance, waterways, farm locations and climatic factors into a geospatial model, to predict risk to farms and wildlife in Australia.  
            </div>
            <div>
                This work is done by UNSW PhD student, Pan Zhang with supervisors Prof Raina MacIntyre, Dr Ashley Quigley and A/Prof Samsung Lim.
            </div>
        </div>
        </div>
      <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'

export default {
  name: 'AvianInfluenza',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner
  },
  data: () => ({
    headerButtons: [],
  })
}
</script>